import { branch, compose, renderComponent } from 'recompose';
import { connect } from 'react-redux';

import { canUseEcommerce, canUseMailchimp, isBrandOrSingleShopBrand } from '../../../common/helpers/users';
import { BRAND_USER_BASE_URL } from '../../../constants';
import IntegrationsOutlet from './IntegrationsOutlet';
import IntegrationsPage from './IntegrationsPage';

const mapStateToProps = state => ({
  baseUrl: BRAND_USER_BASE_URL,
  ecommerceIntegrationEnabled: canUseEcommerce(state) && isBrandOrSingleShopBrand(state),
  mailchimpIntegrationEnabled: canUseMailchimp(state) && isBrandOrSingleShopBrand(state),
});

export default compose(
  connect(mapStateToProps),
  branch(
    props => props.children,
    renderComponent(IntegrationsOutlet),
  ),
)(IntegrationsPage);
